import React from 'react';
import { Tag, TagProps } from '@chakra-ui/react';

export const BlgBadge = ({ children, ...props }: TagProps) => {
  const defaultStyle: TagProps = {
    borderRadius: 'full',
    variant: 'outline',
    size: 'sm',
  };
  return (
    <Tag {...defaultStyle} {...props}>
      {children}
    </Tag>
  );
};
